export default (theme) => ({
  toolbar: {
    //borderBottom: "1px solid #cac5c5d9",
  },
  toolbarIcon: {
    padding: 8,
    paddingTop: 0,
    paddingBottom: 0,
    boxShadow: "none",
    "&&:hover": {
      backgroundColor: "transparent",
    },
    display: "inline-block",
  },
  toolbarText: {
    marginLeft: 10
  },
  owershipInput: {
    width: 90
  }
});